<template>
  <div class="card mt-5 mb-3">
    <div class="card-body pb-1">
      <h5 class="card-title">
        References
        <span class="badge badge-secondary ml-auto">{{
          currentNote.links.from.length
        }}</span>
      </h5>
      <hr />
      <div
        v-for="noteId in currentNote.links.from"
        :key="noteId"
        class="alert alert-secondary"
        role="alert"
      >
        <router-link
          :to="{
            name: 'noteByContextion',
            params: { contextion: getContextion(noteId) }
          }"
          class="d-flex align-items-center"
        >
          <i class="far fa-file-alt fa-fw mr-1" />
          {{ getNoteById(noteId).title.substr(0, 20) }}
          <div class="text-muted"></div>
        </router-link>
        <!-- <span v-html="getSummaryReference(noteId)"></span> -->
      </div>
    </div>
  </div>
</template>
<script>
import goToNote from '@/mixins/go-to-note'
import { mdToHtml } from '@/utils/markdown'
import { mapGetters } from 'vuex'

export default {
  props: ['currentNote'],
  mixins: [goToNote],
  computed: {
    ...mapGetters(['getNoteById'])
  },
  methods: {
    getSummaryReference(noteId) {
      const { content, title } = this.getNoteById(noteId)
      if (content) {
        const summary = mdToHtml(content.substr((content.indexOf(title) - 150), 250), this.$store)
        const replaceTo = '<span class="text-primary bg-light">$&</span>'
        return summary.replace(new RegExp(title, 'ig'), replaceTo)
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
